import React from 'react';
import {
  Filter as RaFilter,
  DateInput,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
} from 'react-admin';
import { filterToQueryBuilder } from '../../../utils/helpers';
import { LOGS_ACTION_TYPES } from '../../../constants/statuses';

export const Filter = (props) => (
  <RaFilter {...props}>
    <ReferenceInput
      alwaysOn
      reference="users"
      source="user.id||$eq"
      label="User"
      resettable
      filterToQuery={filterToQueryBuilder('id', 'fullName', 'email')}
    >
      <AutocompleteInput
        optionText={(entity) => (entity && entity.id ? `(${entity.id}) ${entity.fullName}` : '')}
      />
    </ReferenceInput>
    <SelectInput alwaysOn choices={LOGS_ACTION_TYPES} source="action" label="Action" />
    <DateInput label="Created from" alwaysOn source="createdAt||$gte" />
    <DateInput label="Created to" alwaysOn source="createdAt||$lt" />
  </RaFilter>
);
